
import { Component, Prop, Ref, Vue } from 'vue-property-decorator';

// Components
import VSpinner from '@/components/VSpinner.vue';
import VTableRowEmpty from '@/components/VTableRowEmpty.vue';

@Component({
    components: {
        VSpinner,
        VTableRowEmpty,
    },
})
export default class VTable extends Vue {
    @Prop({ type: Boolean, default: false })
    public outlined!: boolean;

    @Prop({ type: Boolean, default: false })
    public scrollable!: boolean;

    @Prop({ type: Boolean, default: false })
    public fillable!: boolean;

    @Prop({ type: Boolean, default: false })
    public columns!: boolean;

    @Prop({ type: Boolean, default: false })
    public loading!: boolean;

    @Ref() refTable!: HTMLDivElement;

    // Scroll position
    onLeft = true;
    onTop = true;

    params = {
        scrollTop: 0,
        scrollLeft: 0,
        offsetHeight: 0,
    };

    mounted() {
        this.params.offsetHeight = this.refTable.offsetHeight;
    }

    handleScroll(event: Event) {
        const { target } = event;
        const { scrollLeft, scrollTop, offsetHeight } = target as HTMLElement;
        this.onTop = scrollTop === 0;
        this.onLeft = scrollLeft === 0;

        this.params.scrollLeft = scrollLeft;
        this.params.scrollTop = scrollTop;
        this.params.offsetHeight = offsetHeight;
    }
}
